module.exports = __webpack_public_path__ + "img/physical-therapy.e7d989b7.png";